<template>
  <div>
    <grid-x col="1fr 1fr" row="1fr" gap="2em">
      <div class="col-1">
        <h3>Categories</h3>
        <div class="widget-buttons">
          <button v-on:click="updateCacheCategories()">Update Category Cache</button>
        </div>
        <ul>
          <template v-for="(cat,key) in categories">
            <li
              :key="key"
              @click="currentCat = cat;currentCatObj = cat;"
              :class="activeClass(cat, currentCat)"
            >{{cat.name}}</li>
            <li
              v-for="(subcat,subkey) in cat.subcategories"
              @click="currentCat = subcat;currentCatObj = cat;"
              :key="key + '-' + subkey"
              :class="activeClass(subcat, currentCat)"
            >{{cat.name}} || {{subcat.name}}</li>
          </template>
        </ul>
      </div>
      <div class="col-2">
        <h3>Podcast</h3>
        <div class="widget-buttons">
          <button v-on:click="addPodcast">Add podcast</button>
        </div>
        <div v-for="(podcast,podkey) in currentCat.podcasts" :key="podkey" class="flex-row">
          <div class="input-box down-caret">
            <select
              v-model="podcast.playlist"
              :key="'--' +podkey"
              ref="addPodcastSelector"
              @change="selected()"
              @focus="changeColor()"
            >
              <option disabled value>Select a podcast</option>
              <option
                v-for="(item,optionkey) in podcasts"
                :value="{slug: item['.key'], title: item.title}"
                :key="optionkey"
              >{{ item.title }}</option>
            </select>
          </div>
          <div class="widget-buttons">
            <button v-on:click="currentCat.podcasts.splice(podkey,1)">Remove</button>
            <button v-on:click="saveCurrentCat">Save</button>
          </div>
        </div>
      </div>
    </grid-x>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import VueFirestore from "vue-firestore";
require("firebase/firestore");
Vue.use(VueFirestore);
var firestore;

import gridX from "../widgets/gridX";

export default {
  components: { gridX },
  props: ["podcasts"],
  firestore() {
    return {
      // Collection
      categories: firestore.collection("categories")
    };
  },
  data: function() {
    firestore = firebase.firestore();
    return {
      currentCat: {
        podcasts: []
      },
      currentCatObj: {}
    };
  },
  methods: {
    addPodcast: function() {
      if (!this.currentCat.podcasts) {
        Vue.set(this.currentCat, "podcasts", [{ playlist: {} }]);
        return;
      }

      this.currentCat.podcasts.push({ playlist: {} });
    },
    saveCurrentCat: function() {
      var clone = { ...this.currentCatObj };
      delete clone[".key"];
      this.$firestore.categories.doc(this.currentCatObj[".key"]).update(clone);
    },
    activeClass: function(a, b) {
      if (a == b) return "active";
      return "";
    },
    updateCacheCategories: function() {
      firebase
        .firestore()
        .collection("posts")
        .orderBy("timestamp", "desc")
        .limit(1500)
        .get()
        .then(postSnap => {
          var postArray = postSnap.docs.map(doc => doc.data());
          postArray.forEach(post => {
            var foundCat = false;
            if (!post.parentCategory || post.type != "post") return;
            for (var i in this.categories) {
              if (this.categories[i].name == post.parentCategory) {
                foundCat = true;
                if (!post.subCategory || post.subCategory == "") break;
                var foundSub = false;
                if (this.categories[i].subcategories) {
                  this.categories[i].subcategories.some(subcat => {
                    if (subcat.name == post.subCategory) {
                      foundSub = true;
                      return true;
                    }
                  });
                  if (!foundSub) {
                    this.categories[i].subcategories.push({
                      name: post.subCategory
                    });
                  }
                } else {
                  this.categories[i].subcategories = [
                    {
                      name: post.subCategory
                    }
                  ];
                }

                break;
              }
            }
            if (!foundCat) {
              var catObj = {
                name: post.parentCategory
              };
              if (post.subCategory && post.subCategory != "") {
                catObj.subcategories = [
                  {
                    name: post.subCategory
                  }
                ];
              }

              firebase
                .firestore()
                .collection("categories")
                .doc(post.parentCategory)
                .set(catObj);
            }
          });
        })
        .then(() => {
          console.log(this.categories);
          for (var i in this.categories) {
            if (this.categories[i].subcategories) {
              firebase
                .firestore()
                .collection("categories")
                .doc(this.categories[i][".key"])
                .update({
                  subcategories: this.categories[i].subcategories
                });
            }
          }
        });
    },
    selected: function() {
      this.$refs.addPodCastSelector.style.setProperty(
        "--inputColor",
        "aliceblue"
      );
    },
    changeColor: function() {
      this.$refs.addPodcastSelector.style.setProperty("--inputColor", "black");
    }
  }
};
</script>



// WEBPACK FOOTER //
// categories.vue?6fd62d92